(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-alternate"]) return;
  try {
    
  
const mainImage = document.getElementById('main-image')
const variantId = document.querySelectorAll('#vairiant-images');


function imageSwap(e) {
  mainImage.src = this.getAttribute('data-large');
};

for (var i = 0; i < variantId.length; i++) {
    variantId[i].addEventListener('click', imageSwap, false);
}  
  

  } catch(e) { console.error(e); }
})();
})();
